module.exports = __webpack_public_path__ + "img/471.353e456b.png";